import React, { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import clinicService from '../../services/clinic.service'
import ClinicThemeShell from '../layout/ClinicThemeShell'
import Feedback from './Feedback'
import './reputation.css'

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

const sanitizePatientId = (value) => {
  if (!value || typeof value !== 'string') return null
  const trimmed = value.trim()
  return UUID_REGEX.test(trimmed) ? trimmed : null
}

const ClinicReputation = () => {
  const { shortCode } = useParams()
  const [searchParams] = useSearchParams()
  const [clinic, setClinic] = useState(null)
  const [patientID, setPatientID] = useState(null)
  const [loading, setLoading] = useState(true)
  const [notFound, setNotFound] = useState(false)

  useEffect(() => {
    setPatientID(sanitizePatientId(searchParams.get('pId')))
    setLoading(true)
    setNotFound(false)

    clinicService
      .getClinicByShortCode(shortCode)
      .then((res) => {
        setClinic(res.data)
      })
      .catch(() => {
        setClinic(null)
        setNotFound(true)
      })
      .finally(() => setLoading(false))
  }, [shortCode, searchParams])

  if (loading) {
    return (
      <div className="rep-loading">
        <div className="rep-spinner" role="status" aria-label="Loading" />
      </div>
    )
  }

  if (notFound || !clinic?.ID) {
    return (
      <div className="rep-page rep-page--standalone">
        <Helmet>
          <title>EyeconX | Page not found</title>
        </Helmet>
        <div className="rep-not-found">
          <h1>Page not found</h1>
          <p>This feedback link is invalid or no longer available.</p>
        </div>
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>{clinic.name ? `${clinic.name} | Feedback` : 'EyeconX | Feedback'}</title>
      </Helmet>
      <ClinicThemeShell
        clinicId={clinic.ID}
        contentMaxWidth="sm"
        contentClassName="rep-theme-main"
        atmosphere
      >
        <div className="rep-shell">
          <Feedback clinic={clinic} patientID={patientID} />
        </div>
      </ClinicThemeShell>
    </>
  )
}

export default ClinicReputation
